export class AssessmentPanelUtils {
  /**
   * @description Create and return an HTML element.
   */
  static createElement(_document: Document, type: string, label: string, id: string) {
    const element = _document.createElement(type);
    const elementLabel = _document.createTextNode(label);
    element.id = id;
    element.append(elementLabel);
    return element;
  }

  /**
   * @description Create and return an HTML container element (e.g. div).
   */
  static createContainerElement(_document: Document, type: string, children: Node[], classes: string) {
    const element = _document.createElement(type);
    children.forEach((c) => {
      element.append(c);
    });

    element.setAttribute('class', classes);
    return element;
  }

  /**
   * @desciption Method to set attributes of HTML element.
   */
  static setElementAttribute(
    element: Element,
    classes: string,
    ariaLabel: string,
    tabindex: string,
    disabled?: boolean,
  ) {
    element.setAttribute('class', classes);
    element.setAttribute('aria-label', ariaLabel);
    element.setAttribute('tabindex', tabindex);
    if (disabled) {
      element.setAttribute('disabled', 'true');
    }
    return element;
  }
}
